/* tslint:disable */
/* eslint-disable */
export enum WorkVoucherAmountBasisEnum {
  Excl = 'excl',
  Incl = 'incl'
}
